<script setup>
defineProps({
	src: {
		type: String,
		default: null,
	},
})
</script>

<template>
	<div v-if="src" style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 75%">
		<iframe :src="src" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0" allowfullscreen></iframe>
	</div>
</template>
